<template>
  <input
    :type="type"
    :id="id ?? name"
    :name="name"
    :class="[
      focusFocusClass,
      transitionClass,
      paddingClass,
      noBorder ? '':borderClass,
      inputClass,
      textClass,
      'outline-0 dark:bg-slate-700 w-full'
    ]"
    :value="value ?? modelValue"
    @input="input"
    :invalid="invalid"
  />
</template>

<script>
export default {
  name: "RpmDefaultInput",
  props: {
    type: {
      type: String,
    },
    id: {
      type: [String, Number],
      default: null,
    },
    name: {
      type: [String, Number],
      default: "",
    },
    value: {
      default: null,
    },
    modelValue: {
      default: null,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    transitionClass: {
      type: String,
      default: ""
    },
    paddingClass: {
      type: String,
      default: ""
    },
    borderClass: {
      type: String,
      default: ""
    },
    focusFocusClass: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
    inputClass: {
      type: String,
      default: ""
    },
    noBorder: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    input(event) {
      this.$emit("update:modelValue", event.target.value);
    },
  },
};
</script>
